import "./PageLearnMore.scss";
import Footer from "../Footer/Footer";
import SlidingHeader from "../SlidingHeader/SlidingHeader";
import Navbar from "../Navbar/Navbar";
import vid from "../Assets/Design/LearnMoreBanner.mp4";
import fb from "../Assets/Design/LearnMore/fbcircle.png";
import insta from "../Assets/Design/LearnMore/instagramcircle.png";
import shop from "../Assets/Design/LearnMore/shopeecircle.png";
import mess from "../Assets/Design/LearnMore/messengercircle.png";
import denden from "../Assets/Design/LearnMore/dendenmushi.png";
import email from "../Assets/Design/LearnMore/emailcircle.png";
import phone from "../Assets/Design/LearnMore/phonecircle.png";
import { Link, redirect, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
export default function PageLearnMore() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.state?.section) {
      const el = document.getElementById(location.state.section);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <>
      <SlidingHeader />
      <Navbar />
      <div className="learnmore-container">
        {" "}
        <video
          key={vid}
          autoPlay
          muted
          loop
          playsInline
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        >
          <source src={vid} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="section1" id="aboutus"></div>
        <div className="section2"></div>
        <div className="section3"></div>
        <div className="section4"></div>
        <div className="contact-wrapper" id="contactus">
          <img src={denden} className="denden" />
          <div className="find-us-online">
            <div className="blank"></div>
            <div className="icons-wrapper">
              <img
                src={fb}
                className="fb"
                onClick={() => {
                  window.location.href =
                    "http://www.facebook.com/littlekidinside";
                }}
              />
              <img
                src={insta}
                className="insta"
                onClick={() => {
                  window.location.href =
                    "http://www.instagram.com/little_kid_inside";
                }}
              />
              <img
                src={shop}
                className="shop"
                onClick={() => {
                  window.location.href = "http://www.shopee.ph/littlekidinside";
                }}
              />
              <img
                src={mess}
                className="mess"
                onClick={() => {
                  window.location.href =
                    "https://www.facebook.com/messages/t/112020700440792";
                }}
              />
            </div>
          </div>
          <div className="contact-us">
            {" "}
            <div className="blank"></div>
            <div className="icons-wrapper">
              <div className="link-wrapper">
                <img src={email} className="email" />
                <span>inquiries@littlekidinside.shop</span>
              </div>
              <div className="link-wrapper">
                <img src={phone} className="phone" />
                <span>+63 926 779 9669</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
